// Shared financial math helpers (pure functions).

// Future value of a series of regular contributions (annuity) + present lump sum.
// rate = periodic rate, n = number of periods, pmt = contribution per period,
// pv = starting balance, contribAtStart = annuity-due vs ordinary.
export function futureValue({ rate, periods, pmt = 0, pv = 0, contribAtStart = false }) {
  const n = periods;
  if (rate === 0) return pv + pmt * n;
  const growth = Math.pow(1 + rate, n);
  const annuity = pmt * ((growth - 1) / rate) * (contribAtStart ? 1 + rate : 1);
  return pv * growth + annuity;
}

// Payment required to reach a future value target.
export function paymentForFV({ rate, periods, fv, pv = 0, contribAtStart = false }) {
  const n = periods;
  const growth = Math.pow(1 + rate, n);
  if (rate === 0) return (fv - pv) / n;
  const factor = ((growth - 1) / rate) * (contribAtStart ? 1 + rate : 1);
  return (fv - pv * growth) / factor;
}

// Convert a nominal annual rate compounded `compPerYear` times into an effective
// periodic rate for `paymentsPerYear` payment frequency. Used for Canadian mortgages
// where fixed loans compound semi-annually (compPerYear = 2).
export function effectivePeriodicRate(annualNominal, compPerYear, paymentsPerYear) {
  if (annualNominal === 0) return 0;
  const effectiveAnnual = Math.pow(1 + annualNominal / compPerYear, compPerYear) - 1;
  return Math.pow(1 + effectiveAnnual, 1 / paymentsPerYear) - 1;
}

// Standard amortizing payment for a loan.
export function amortizedPayment({ principal, periodicRate, periods }) {
  if (periods <= 0) return 0;
  if (periodicRate === 0) return principal / periods;
  const g = Math.pow(1 + periodicRate, periods);
  return (principal * periodicRate * g) / (g - 1);
}

export const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;
